/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-member-accessibility */
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import * as $ from "jquery";
import { ContratElementVariableDto } from "../../dto/GenApi.iNotPaie.Dto/ContratElementVariableDto";
import { ServicesFactoryInstance } from "../Controls/ServicesFactory";
import { VueBase } from "../Controls/VueBase";
import { ParametreDto } from "../../dto/GenApi.iNotPaie.Dto/ParametreDto";
import { ElementVariableDto } from "../../dto/GenApi.iNotPaie.Dto/ElementVariableDto";
import moment from "moment";
import ModalAjoutPeriodeVariable from "./modalAjoutPeriodeVariable/modalAjoutPeriodeVariable";
import ModalMessage from "./modalMessage/modalMessage";
import { EventBus } from "../Controls/EventBus";
import { ParametresInstance } from "../Controls/Parameters";
import { EtatSaisie } from "../../dto/GenApi.iNotPaie.Dto/EtatSaisie";
import ModalParamVariablesPst from "./modalParamVariablesPst/modalParamVariablesPst";
import EventConstants, { RoleConstants } from "../Controls/EventConstants";
import { Location } from "vue-router/types/router";
import ModalCalculBulletin from "./modalCalculBulletin/modalCalculBulletin";
import ModalRecapVariables from "./modalRecapVariables/modalRecapVariables";
import ModalRecapAllVariables from "./modalRecapAllVariables/modalRecapAllVariables";
import { ObjectParsingInstance } from "../Controls/ObjectParsing";
import { NotificationServiceInstance } from "../../shared/services/notification.service";
import { DemandeCalculPaieDto } from "../../dto/GenApi.iNotPaie.Dto/DemandeCalculPaieDto";
import ModalImportCsv from "./modalImportCsv/modalImportCsv";

interface familleModel {
	libelle: string;
	code: string;
	sousFamilles: ParametreDto[];
}

@Component({
	beforeRouteEnter(to, from, next) {
		next(v => {
			const vm = (v as SaisieDesVariables);
			if (to.query.filtre != undefined) {
				vm.filterName = to.query.filtre as string;
			}
		});
	},
	components: {
		ModalMessage: require("./modalMessage/modalMessage.vue.html"),
		ModalRecapVariables: require("./modalRecapVariables/modalRecapVariables.vue.html"),
		ModalRecapAllVariables: require("./modalRecapAllVariables/modalRecapAllVariables.vue.html"),
		ModalCalculBulletin: require("./modalCalculBulletin/modalCalculBulletin.vue.html"),
		ModalAjoutPeriodeVariable: require("./modalAjoutPeriodeVariable/modalAjoutPeriodeVariable.vue.html"),
		ModalParamVariablesPst: require("./modalParamVariablesPst/modalParamVariablesPst.vue.html"),
		ModalImportCsv: require("./modalImportCsv/modalImportCsv.vue.html")
	}
})
export default class SaisieDesVariables extends VueBase {
	contrats: ContratElementVariableDto[] = [];
	contratsBase: ContratElementVariableDto[] = [];
	contratsFiltred: ContratElementVariableDto[] = [];
	filterName = "";
	filterVariable = "";
	curentOrberColumn = "FullName";
	orderingDesc = true;
	colorCache: string[] = ["#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e", "#16a085", "#27ae60", "#8e44ad", "#2c3e50", "#f1c40f", "#e67e22", "#e74c3c", "#95a5a6", "#f39c12", "#d35400", "#c0392b", "#bdc3c7", "#7f8c8d"];
	dataReady = false;
	roles: string[] = [];
	modeSalarieHaut = false;
	isUtilisateurPst = false;
	HasMessageInformation = false;
	familles: familleModel[] = [{ code: "", libelle: "Toutes les catégories", sousFamilles: [{ Id: 0, Code: "Tous", Libelle: "Tous les scénarios", Modifiable: false, EstVisiblePst: true, EstVisibleEtudePst: true, EstArchive: false }] },
    	{ code: "0/", libelle: "Scénarios courants", sousFamilles: [] },
    	{ code: "1/", libelle: "Scénarios exceptionnels", sousFamilles: [] },
    	{ code: "2/", libelle: "Scénarios de départ", sousFamilles: [] }];

	etatSaisie?: EtatSaisie = undefined;
	displayMessageContrat = true;
	displaySocietePst = false;
	allowImportCsv = false;
	canEditVariables = true;
	displayButton = false;
	sousFamille: ParametreDto[] = [];
	selectedCodeFamille = "";
	selectedCodeSousFamille?: string = "";
	listeRubrique: ParametreDto[] = [];
	listeRubriqueFiltred: ParametreDto[] = [];

	modalCalculBulletin?: ModalCalculBulletin = undefined;
	modalRecapVariables?: ModalRecapVariables = undefined;
	modalRecapAllVariables?: ModalRecapAllVariables = undefined;
	modalAjoutPeriodeVariable?: ModalAjoutPeriodeVariable = undefined;
	modalParamVariablesPst?: ModalParamVariablesPst = undefined;
	modalMessage?: ModalMessage = undefined;
	modalImportCsv?: ModalImportCsv = undefined;
	allSelected = false;

	leftPosition = 0;

	changeModeSalarieHaut(val: boolean) {
    	if (!this.dataReady || this.modeSalarieHaut == val) {
			return;
		}

    	this.modeSalarieHaut = val;
    	this.saveProfilUtilisateur();
	}

	checkIsModified(location: Location): boolean {
    	return super.checkIsModified(location);
	}

	@Watch("selectedCodeFamille")
	onSelectedCodeFamilleChanged(value: string, oldValue: string) {
    	if (value == oldValue) {
			return;
		}
    	const famille = this.familles.filter(f => f.code == this.selectedCodeFamille);
    	if (famille.length == 1) {
    		this.sousFamille = famille[0].sousFamilles;
    	}
    	if (this.sousFamille.length > 0 && this.sousFamille[0].Code != undefined) {
    		this.selectedCodeSousFamille = this.sousFamille[0].Code;
    	}
	}

	@Watch("selectedCodeSousFamille")
	onSelectedCodeSousFamilleChanged(value?: string, oldValue?: string) {
		if (ParametresInstance.utilisateurCourant == undefined) {
			return;
		}

    	this.listeRubrique = [];
    	if (!this.isUtilisateurPst && value != "Tous") {
			ServicesFactoryInstance.VariablesService.getVariables(this.selectedCodeSousFamille, data => {
    			this.listeRubrique = data;
    			this.doFilterVariable();
    		});
		} else {
			ServicesFactoryInstance.VariablesService.getVariables("", data => {
    			this.listeRubrique = data;
    			this.doFilterVariable();
    		});
		}
	}

	doFilterVariable() {
    	if (this.isUtilisateurPst) {
    		this.listeRubriqueFiltred = ObjectParsingInstance.removeDuplicateByUniqueKey(this.listeRubrique.filter(d => d.EstVisibleEtudePst), "Id");
    	} else {
			this.listeRubriqueFiltred = this.listeRubrique;
		}

    	// TODO : Rajouter une recherche de variables
    	if (this.filterVariable != "") {
    		this.listeRubriqueFiltred = this.listeRubriqueFiltred.filter(v => (v.Code != undefined && v.Code.toLowerCase().indexOf(this.filterVariable.toLowerCase()) > -1) || (v.Libelle != undefined && v.Libelle.toLowerCase().indexOf(this.filterVariable.toLowerCase()) > -1));
    	}
	}

	click_check(target) {
    	const element: HTMLElement = document.getElementById(target) as HTMLElement;
    	element.click();
	}

	openAddItemForSelected(codeRubrique: string, codeNature: string, codeVariable: string) {
		if (this.modalAjoutPeriodeVariable == undefined) {
			this.modalAjoutPeriodeVariable = this.$refs.modalAjoutPeriodeVariable as ModalAjoutPeriodeVariable;
		}

    	this.modalAjoutPeriodeVariable.setElementVariable(true, undefined, codeRubrique, codeNature, codeVariable);
    	$("#modalAjoutPeriodeVariable").modal("show");
	}

	messageAdded(param) {
    	if (param.NumeroContrat == 0) {
    		this.HasMessageInformation = true;

    		return;
    	}
    	for (let i = 0; i < this.contratsFiltred.length; i++) {
			const c: ContratElementVariableDto = this.contratsFiltred[i];
			if (c.Id == param.IdContratFk && param.TypeMessage == "I") {
    			c.HasMessageInformation = true;

    			return;
    		}
			if (c.Id == param.IdContratFk && param.TypeMessage == "E") {
    			c.HasMessageContrat = true;

    			return;
    		}
    	}
	}

	messageDeleted(param) {
    	if (param.NumeroContrat == 0) {
    		this.HasMessageInformation = false;

    		return;
    	}
    	for (let i = 0; i < this.contratsFiltred.length; i++) {
			const c: ContratElementVariableDto = this.contratsFiltred[i];
			if (c.Id == param.IdContratFk && param.TypeMessage == "I") {
    			c.HasMessageInformation = false;

    			return;
    		}
			if (c.Id == param.IdContratFk && param.TypeMessage == "E") {
    			c.HasMessageContrat = false;

    			return;
    		}
    	}
	}

	validateAjoutAll(param) {
		for (let i = 0; i < this.contratsFiltred.length; i++) {
    		const c: any = this.contratsFiltred[i];
    		if (c.selected) {
    			const contrat = this.contratsFiltred[i];
    			const variable = contrat.ElementVariables.filter(e => e.CodeRubrique == param.codeRubrique && e.CodeNature == param.codeNature);

    			if (variable.length > 0) {
    				variable[0].Montant = param.value;
    				variable[0].DateDebut = param.dateDebut;
    				variable[0].DateFin = param.dateFin;
    				variable[0].CodeVariable = param.codeVariable;
    			} else {
    				contrat.ElementVariables.push({
    					Id: 0,
    					CodeRubrique: param.codeRubrique,
    					CodeNature: param.codeNature,
    					DateDebut: param.dateDebut,
    					DateFin: param.dateFin,
    					Montant: param.value,
    					CodeTypeElementVariable: "VARIA",
    					CodeVariable: param.codeVariable,
						EstSoumise: true,
						EstValidee: true
    				});
    			}
    			c.selected = false;
    		}
		}
	}

	allSelectedChanged() {
    	for (let i = 0; i < this.contratsFiltred.length; i++) {
			const c: any = this.contratsFiltred[i];
			c.selected = !this.isSaisieVariableDisabled(c) && this.allSelected;
    	}
	}

	setDisplayOptions(): any {
    	if (ParametresInstance.societeCourante == undefined) {
    		this.displayMessageContrat = false;
    		this.canEditVariables = false;

    		return;
    	}
    	ServicesFactoryInstance.ExercicesService.getMessage("I", 0, data => {
    		this.HasMessageInformation = data != null;
    	});
    	this.etatSaisie = ParametresInstance.societeCourante.EtatSaisie;
    	this.displayMessageContrat = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]);
    	this.canEditVariables = ParametresInstance.userIsAuthorized([RoleConstants.Payeur, RoleConstants.AdministrateurPST]) || this.etatSaisie == EtatSaisie.SaisieEnCours;
		this.displaySocietePst = ParametresInstance.isPst;
		this.allowImportCsv = ParametresInstance.userIsAuthorized([RoleConstants.Administrateur, RoleConstants.AdministrateurPST, RoleConstants.Payeur]);
	}

	ParamVariables() {
		if (this.modalParamVariablesPst == undefined) {
			this.modalParamVariablesPst = this.$refs.modalParamVariablesPst as ModalParamVariablesPst;
		}

    	if (this.modalParamVariablesPst == undefined) {
			return;
		}
    	this.modalParamVariablesPst.Init();
    	$("#modalParamVariablesPst").modal("show");
	}

	checkEtatSaisie(etat: number): boolean {
    	if (this.etatSaisie == etat) {
			return true;
		}

    	return false;
	}

	saveProfilUtilisateur() {
    	if (ParametresInstance.utilisateurCourant != undefined && ParametresInstance.utilisateurCourant.ProfilUtilisateur) {
    		ParametresInstance.utilisateurCourant.ProfilUtilisateur.SaisieVariablesConfiguration.ModeSalarieHaut = this.modeSalarieHaut;
    		this.dataReady = false;
    		ServicesFactoryInstance.UtilisateurService.updateProfil(ParametresInstance.utilisateurCourant.ProfilUtilisateur, () => {
    			this.dataReady = true;
    		}, () => {
    			this.dataReady = true;
    		});
    	}
	}

	mounted() {
    	EventBus.$on(EventConstants.UTILISATEUR_CHANGED, obj => {
    		if (ParametresInstance.utilisateurCourant != undefined && ParametresInstance.utilisateurCourant.ProfilUtilisateur) {
    			this.modeSalarieHaut = ParametresInstance.utilisateurCourant.ProfilUtilisateur.SaisieVariablesConfiguration.ModeSalarieHaut;
    		}
    	});

    	EventBus.$on(EventConstants.SOCIETE_CHANGED, obj => {
    		this.annuler();
    	});

    	if (ParametresInstance.utilisateurCourant != undefined && ParametresInstance.utilisateurCourant.ProfilUtilisateur) {
    		this.modeSalarieHaut = ParametresInstance.utilisateurCourant.ProfilUtilisateur.SaisieVariablesConfiguration.ModeSalarieHaut;
    	}

    	this.getFamilles();
    	this.modalAjoutPeriodeVariable = this.$refs.modalAjoutPeriodeVariable as ModalAjoutPeriodeVariable;
    	EventBus.$on(EventConstants.IS_PST_CHANGED, this.setDisplayOptions);
    	EventBus.$on(EventConstants.ETAT_SAISIE_CHANGED, this.setDisplayOptions);

    	if (ParametresInstance.societeCourante != undefined) {
			this.etatSaisie = ParametresInstance.societeCourante.EtatSaisie;
		}

		this.fetchData();
		this.setUserRole();
		this.setDisplayOptions();
	}

	setUserRole() {
    	this.isUtilisateurPst = ParametresInstance.userHasRole(RoleConstants.UtilisateurPST);

    	this.onSelectedCodeSousFamilleChanged(this.selectedCodeSousFamille, this.selectedCodeSousFamille);
	}

	getFamilles() {
    	ServicesFactoryInstance.ParametresService.getTypeVariable(data => {
    		for (let i = 0; i < data.length; i++) {
    			for (let j = 0; j < this.familles.length; j++) {
    				const typeVariable = data[i];
    				const famille = this.familles[j];

    				const complement: string = typeVariable.Complement != undefined ? typeVariable.Complement : "";

    				if (complement.indexOf(famille.code) == 0) {
    					famille.sousFamilles.push(typeVariable);
    				}
    			}
    		}
    		this.sousFamille = this.familles[0].sousFamilles;

    		if (this.sousFamille.length > 0 && this.sousFamille[0].Code != undefined) {
    			this.selectedCodeSousFamille = this.sousFamille[0].Code;
    		}
    	});
	}

	getSizeEchelle(): any {
    	const listeContainer: any = this.$refs.listeSalarieBodyCard;
    	if (listeContainer != undefined && listeContainer.clientHeight != undefined) {
    		const hauteurEchelle = Number(listeContainer.clientHeight) - 70;

    		return {
    			height: hauteurEchelle + "px"
    		};
    	} else {
			return {};
		}
	}

	fetchData() {
		this.dataReady = false;

    	ServicesFactoryInstance.VariablesService.getContratVariables(async(data) => {
			this.contrats = data;
			this.contratsBase = this.copy(data) as ContratElementVariableDto[];
    		this.contratsFiltred = this.contrats;
			await this.doFilter();
			this.dataReady = true;
		});
	}

	doFilter() {
    	if (this.filterName != undefined && this.filterName != "") {
			this.contratsFiltred = this.contrats.filter(s => s.FullName != undefined &&
                (s.FullName.toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0 ||
                    (s.NumeroSalarie.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0 ||
                        (s.NumeroContrat.toString().toUpperCase().indexOf(this.filterName.toUpperCase()) >= 0))));
		} else {
			this.contratsFiltred = this.contrats;
		}

    	this.doOrder();
	}

	oderBy(columnName) {
    	if (this.curentOrberColumn == columnName) {
    		this.orderingDesc = !this.orderingDesc;
    	} else {
    		this.orderingDesc = true;
    	}
    	this.curentOrberColumn = columnName;
    	this.doOrder();
	}

	doOrder() {
    	const orderingDesc = this.orderingDesc;
    	const columnName = this.curentOrberColumn;
    	if (this.contrats != undefined) {
    		this.contrats = this.contrats.sort(function(a, b) {
    			if (a[columnName] < b[columnName]) {
					return (orderingDesc ? -1 : 1);
				}
    			if (a[columnName] > b[columnName]) {
					return (orderingDesc ? 1 : -1);
				}

    			return 0;
    		});
    	}
	}

	openMessageContrat(numeroContrat, idContrat, nomSalarie, typeMessage, isUserPst = false) {
    	if (this.modalMessage == undefined) {
			this.modalMessage = this.$refs.modalMessage as ModalMessage;
		}

		let isDisabled = false;
		if (isUserPst) {
			isDisabled = this.checkEtatSaisie(EtatSaisie.SaisieCloturee);
		}

		this.modalMessage.Init(numeroContrat, nomSalarie, typeMessage, idContrat, isDisabled);
    	$("#modalMessage").modal("show");
	}

	openSalarie(idSalarie, titre) {
    	EventBus.NavigateTo({ path: "/ficheSalarie/" + idSalarie, query: { titre: titre } });
	}

	getClassOfOrder(columnName, desc): string {
    	if (columnName == this.curentOrberColumn && this.orderingDesc == desc) {
    		return "active";
    	}

    	return "icons";
	}

	randomColor(color): string {
    	const r = () => Math.floor(256 * Math.random());

    	return this.colorCache[color] || (this.colorCache[color] = `rgb(${r()}, ${r()}, ${r()})`);
	}

	calculerBuletin(contrat: ContratElementVariableDto) {
		if (!this.dataReady) {
			return;
		}
		this.dataReady = false;

		this.changeValiderSaisieState(true);

		if (ParametresInstance.societeCourante == undefined) {
			NotificationServiceInstance.SendFailed("Vous n'avez pas sélectionné de société.");
			this.changeValiderSaisieState(false);
			this.dataReady = true;
		} else if (ParametresInstance.societeCourante.PeriodeActive == undefined) {
			NotificationServiceInstance.SendFailed("Vous n'avez pas de période active.");
			this.changeValiderSaisieState(false);
			this.dataReady = true;
		} else {
			const idContrats: number[] = [];
			idContrats.push(contrat.Id);
			const arretSurImage: DemandeCalculPaieDto = { IdSociete: ParametresInstance.societeCourante.Id, IdContrats: idContrats };
			ServicesFactoryInstance.CalculPaieService.calculerPayes(arretSurImage, () => {
				ServicesFactoryInstance.CalculPaieService.existeBulletinFinDeContratSurMoisEnCours(contrat.Id, existeFinDeContrat => {
					// Actualise le marquage Fin de contrat si nécéssaire après calcul du bulletin.
					contrat.EstFinContratSurExerciceEnCours = existeFinDeContrat;
				});

				if (this.modalCalculBulletin == undefined) {
					this.modalCalculBulletin = this.$refs.modalCalculBulletin as ModalCalculBulletin;
				}

				if (this.modalCalculBulletin) {
					this.modalCalculBulletin.getBuletin(contrat.Id);
					this.changeValiderSaisieState(false);
					this.dataReady = true;
					$("#modalCalculBulletin").modal("show");
				} else {
					this.changeValiderSaisieState(false);
					this.dataReady = true;
				}
			}, () => {
				this.changeValiderSaisieState(false);
				this.dataReady = true;
			});
		}
	}

	containVariable(contrat: ContratElementVariableDto): boolean {
    	return contrat.ElementVariables.length > 0;
	}

	viewDetails(contrat: ContratElementVariableDto) {
		 if (this.modalRecapVariables == undefined) {
			this.modalRecapVariables = this.$refs.modalRecapVariables as ModalRecapVariables;
		 }

		 if (this.modalRecapVariables == undefined) {
			return;
		 }

		 this.modalRecapVariables.getDetails(contrat);

		 $("#modalRecapVariables").modal("show");
	}

	viewAllDetails() {
		if (this.modalRecapAllVariables == undefined) {
			this.modalRecapAllVariables = this.$refs.modalRecapAllVariables as ModalRecapAllVariables;
		}

    	if (this.modalRecapAllVariables == undefined) {
			false;
		}
    	this.modalRecapAllVariables.getDetails(this.contratsFiltred);

    	$("#modalRecapAllVariables").modal("show");
	}

	getMontant(codeRubrique: string, codeNature: string, contrat: ContratElementVariableDto): string {
    	const variable = contrat.ElementVariables.filter(e => e.CodeRubrique == codeRubrique && e.CodeNature == codeNature);
    	if (variable.length > 0) {
    		const varia = variable[0];
    		const montantLibelle = varia.Montant != undefined ? varia.Montant.toString() : "";

    		return montantLibelle;
    	}

    	return "";
	}

	getPeriode(codeRubrique: string, codeNature: string, contrat: ContratElementVariableDto): string {
    	const variable = contrat.ElementVariables.filter(e => e.CodeRubrique == codeRubrique && e.CodeNature == codeNature);
    	if (variable.length > 0) {
    		const varia = variable[0];
    		if (varia.Montant != undefined && varia.DateDebut != undefined) {
    			let libellePeriode = moment.utc(varia.DateDebut).format("MMM YY");
    			if (varia.DateFin != undefined) {
    				libellePeriode += " > " + moment.utc(varia.DateFin).format("MMM YY");
    			}

    			return libellePeriode;
    		}
    	}

    	return "";
	}

	openPeriodeSettings(codeRubrique: string, codeNature: string, contrat: ContratElementVariableDto) {
    	if (this.modalAjoutPeriodeVariable == undefined) {
			this.modalAjoutPeriodeVariable = this.$refs.modalAjoutPeriodeVariable as ModalAjoutPeriodeVariable;
		}
    	const variable = contrat.ElementVariables.filter(e => e.CodeRubrique == codeRubrique && e.CodeNature == codeNature);
    	if (variable.length == 0) {
			return;
		}

    	this.modalAjoutPeriodeVariable.setElementVariable(false, contrat.Id, variable[0].CodeRubrique, variable[0].CodeNature, undefined, variable[0].DateDebut, variable[0].DateFin, variable[0].Montant);

    	$("#modalAjoutPeriodeVariable").modal("show");
	}

	checkSelected() {
    	this.displayButton = this.contratsFiltred.filter(c => (c as any).selected == true).length > 0;
	}

	validatePeriode(param) {
		const selected = param.selected;

		if (selected) {
			this.validateAjoutAll(param);
			this.allSelected = false;
		} else {
			const contrat = this.contrats.filter(c => c.Id == param.idContrat)[0];
			const variable = contrat.ElementVariables.filter(e => e.CodeRubrique == param.codeRubrique && e.CodeNature == param.codeNature);
			if (variable.length == 0) {
				return;
			}

			variable[0].DateDebut = param.dateDebut;
			variable[0].DateFin = param.dateFin;
		}

		this.isModified = true;
		this.displayButton = false;
		this.$forceUpdate();
	}

	enregistrer() {
    	this.dataReady = false;

		//Initialisation du tableau des contrats à sauvegarder en se basant sur l'état actuel du formulaire
		let contratsToSave: ContratElementVariableDto[] = this.copy(this.contrats) as ContratElementVariableDto[];
		contratsToSave.forEach((contrat) => {
			contrat.Photo = undefined;
		});

		//Ajout des variables supprimées
		contratsToSave.forEach((contratToSave) => {
			const contratBase = this.contratsBase.filter(c => c.Id == contratToSave.Id)[0];
			contratBase.ElementVariables.forEach((variableBase) => {
				const variableToSave = contratToSave.ElementVariables.filter(v => v.CodeRubrique == variableBase.CodeRubrique
                                                                                && v.CodeNature == variableBase.CodeNature
                                                                                && v.CodeTypeElementVariable == variableBase.CodeTypeElementVariable)[0];
				//Si on ne retrouve pas la variable => elle a été supprimée
				if (!variableToSave) {
					let variableBaseUpdated = this.copy(variableBase);
					//Mettre le montant à null pour que le backend supprime la variable
					variableBaseUpdated.Montant = undefined;
					contratToSave.ElementVariables.push(variableBaseUpdated);
					//Si on retrouve la variable et qu'il n'y a pas de modification => elle n'a pas été modifié
				} else if (variableToSave.Montant == variableBase.Montant
                    && this.comparerDates(variableToSave.DateDebut, variableBase.DateDebut)
                    && this.comparerDates(variableToSave.DateFin, variableBase.DateFin)) {
					const indexVaria = contratToSave.ElementVariables.indexOf(variableToSave, 0);

					if (indexVaria !== -1) {
						contratToSave.ElementVariables.splice(indexVaria, 1);
					}
				}
			});
		});

		//Suppresions des contrats où aucune variable n'est renseignée
		contratsToSave = contratsToSave.filter(c => c.ElementVariables.length > 0);
        
		ServicesFactoryInstance.VariablesService.updateContratVariables(contratsToSave, (id) => {
    		this.annuler();
    		NotificationServiceInstance.SendSuccess("L'enregistrement des variables s'est correctement déroulé !");
		}, (e) => {
    		this.isModified = false;
    		this.dataReady = true;
    	});
	}

	annuler() {
    	this.isModified = false;
    	this.fetchData();
	}

	onDataChanged(codeRubrique: string, libelle: string, codeNature: string, codeVariable: string, contrat: ContratElementVariableDto, e: any) {
    	if (e.target.value != "" && isNaN(e.target.value)) {
    		e.target.value = this.getMontant(codeRubrique, codeNature, contrat);
    	} else {
    		const variableContrat = contrat.ElementVariables.filter(e => e.CodeRubrique == codeRubrique && e.CodeNature == codeNature);

    		if (variableContrat.length == 0) {
    			const newValue: ElementVariableDto = {
    				Id: 0,
    				CodeRubrique: codeRubrique,
    				LibelleRubrique: libelle,
    				CodeNature: codeNature,
    				CodeTypeElementVariable: "VARIA",
    				CodeVariable: codeVariable,
					EstSoumise: true,
					EstValidee: true
    			};
    			if (e.target.value != "" && !isNaN(Number(e.target.value))) {
					newValue.Montant = Number(e.target.value);
					contrat.ElementVariables.push(newValue);
				}
    		} else {
    			const varia = variableContrat[0];

    			if (e.target.value != "" && !isNaN(Number(e.target.value))) {
					varia.Montant = Number(e.target.value);
				} else {
					const indexVaria = contrat.ElementVariables.indexOf(varia, 0);

					if (indexVaria !== -1) {
						contrat.ElementVariables.splice(indexVaria, 1);
					}
				}
    		}
    		this.isModified = true;
    	}
	}

	getTableWidth(): any {
    	let tableWidth = this.listeRubrique.length * 200;
    	tableWidth += 8; // pour la scrollbar

    	return {
    		width: tableWidth + "px",
    		marginRight: "-18px"
    	};
	}

	getTableWidthDiv(): any {
    	let tableWidth = this.listeRubrique.length * 200;
    	tableWidth += 15;

    	return {
    		width: tableWidth + "px",
    		marginRight: "-18px"
    	};
	}

	getTableNameWidth(): any {
    	let tableWidth = this.listeRubrique.length * 200;
    	tableWidth += 330;

    	return {
    		width: tableWidth + "px",
    		marginRight: "-18px",
    		maxWidth: "100%",
    		minWidth: "320px"
    	};
	}

	getHeadPosition(): any {
    	return {
    		// left: -this.leftPosition + "px"
    	};
	}

	getFirstColumnRub(): any {
    	return {
    		width: "300px",
    		height: "60px",
    		textOverflow: "initial",
    		whiteSpace: "initial"
    		// left: this.leftPosition + "px"
    	};
	}

	getFirstColumn(): any {
    	return {
    		width: "300px",
    		height: "60px"
    		// left: this.leftPosition + "px"
    	};
	}

	scrollFrom = "";
	scrollDetails(event) {
    	if (this.scrollFrom == "scrollNames") {
    		this.scrollFrom = "";

    		return;
    	}
    	this.scrollFrom = "scrollDetails";
    	if (event.srcElement != undefined) {
    		$(".scrollNames").each(function(i, e) {
    			if (e.scrollTop != event.srcElement.scrollTop) {
    				e.scrollTop = event.srcElement.scrollTop;
    			}
    		});
    	}
    	if (event.explicitOriginalTarget != undefined) {
    		$(".scrollNames").each(function(i, e) {
    			if (e.scrollTop != event.explicitOriginalTarget.scrollTop) {
    				e.scrollTop = event.explicitOriginalTarget.scrollTop;
    			}
    		});
    	}
    	if (event.srcElement != undefined) {
    		$(".scrollRubriques").each(function(i, e) {
    			if (e.scrollLeft != event.srcElement.scrollLeft) {
    				e.scrollLeft = event.srcElement.scrollLeft;
    			}
    		});
    	}
    	if (event.explicitOriginalTarget != undefined) {
    		$(".scrollRubriques").each(function(i, e) {
    			if (e.scrollLeft != event.explicitOriginalTarget.scrollLeft) {
    				e.scrollLeft = event.explicitOriginalTarget.scrollLeft;
    			}
    		});
    	}
	}

	scrollNames(event) {
    	if (this.scrollFrom == "scrollDetails") {
    		this.scrollFrom = "";

    		return;
    	}
    	this.scrollFrom = "scrollNames";
    	if (event.srcElement != undefined) {
    		$(".scrollDetails").each(function(i, e) {
    			if (e.scrollTop != event.srcElement.scrollTop) {
    				e.scrollTop = event.srcElement.scrollTop;
    			}
    		});
    	}
    	if (event.explicitOriginalTarget != undefined) {
    		$(".scrollDetails").each(function(i, e) {
    			if (e.scrollTop != event.explicitOriginalTarget.scrollTop) {
    				e.scrollTop = event.explicitOriginalTarget.scrollTop;
    			}
    		});
    	}
	}

	public isSaisieVariableDisabled(ligne: ContratElementVariableDto): boolean {
		if (!this.canEditVariables || !this.dataReady) {
			return true;
		}

		return this.isUtilisateurPst && ligne.EstFinContratSurExerciceEnCours;
	}

	public setClassContratSurExerciceEnCours(contrat: ContratElementVariableDto): string {
		if (contrat.EstFinContratSurExerciceEnCours) {
			return "fin-contrat";
		}

		if (contrat.EstDebutContratSurExerciceEnCours) {
			return "debut-contrat";
		}

		return "";
	}

	public setTitleName(contrat: ContratElementVariableDto): string | undefined {
		if (contrat.EstFinContratSurExerciceEnCours) {
			return `${contrat.FullName} (Sortie dans le mois)`;
		}

		if (contrat.EstDebutContratSurExerciceEnCours) {
			return `${contrat.FullName} (Entrée dans le mois)`;
		}

		return contrat.FullName;
	}

	private openImportCsv(): void {
		if (this.isModified) {
			NotificationServiceInstance.SendWarning("Vous ne pouvez pas effectuer un import CSV tant que vous avez des modifications en cours");

			return;
		}

		if (this.modalImportCsv == undefined) {
			this.modalImportCsv = this.$refs.modalImportCsv as ModalImportCsv;
		}

		this.modalImportCsv.init();
		$("#modalImportCsv").modal("show");
	}

	private validateImport(): void {
		this.fetchData();
	}

	//Permet de changer l'état du bouton "Valider la saisie" dans le bandeau
	private changeValiderSaisieState(disable: boolean): void {
		EventBus.$emit(EventConstants.CHANGE_VALIDER_SAISIE_STATE, disable);
	}
	// Permet de faire une copie d'un élément
	private copy(data): any {
		const copied = JSON.parse(JSON.stringify(data));
		return copied;
	}

	//Permet de comparer 2 dates
	private comparerDates(date1: any, date2: any): boolean {
		// Si les deux valeurs sont undefined, retourner vrai
		if (date1 === undefined && date2 === undefined) {
			return true;
		}

		// Si l'une des deux valeurs est undefined, retourner faux
		if (date1 === undefined || date2 === undefined) {
			return false;
		}
		//On convertit les dates en moment pour ne pas avoir de problème de timezone
		const moment1 = moment.utc(date1);
		const moment2 = moment.utc(date2);

		// Comparer les deux valeurs
		return new Date(moment1.year(), moment1.month(), moment1.date()).toDateString() === new Date(moment2.year(), moment2.month(), moment2.date()).toDateString();
	}
}



// WEBPACK FOOTER //
// ./src/components/saisieDesVariables/saisieDesVariables.ts